import { useTranslation } from "react-i18next";
import { Outlet, useMatch, useResolvedPath } from "react-router";
import { DOMAIN_TERMS } from "src/common/domainTerms.js";
import { LegalEntitiesLayoutView } from "./LegalEntitiesLayoutView.js";

/**
 * Shared header + tabs for the companies list and the group structure editor
 * — previously two disconnected pages ("Koncernstruktur" was a one-way
 * button with no way back except the browser). Tabs, not a button, per
 * portal#4304.
 */
export const LegalEntitiesLayout = () => {
	const { t } = useTranslation();
	const hierarchyPath = useResolvedPath("hierarchy");
	const isHierarchyTab =
		useMatch({ path: hierarchyPath.pathname, end: true }) != null;

	return (
		<LegalEntitiesLayoutView
			isHierarchyTab={isHierarchyTab}
			companiesLabel={t(DOMAIN_TERMS.COMPANIES)}
			groupStructureLabel={t(DOMAIN_TERMS.GROUP_STRUCTURE)}
		>
			<Outlet />
		</LegalEntitiesLayoutView>
	);
};
